export default {
  certifiedVet: `I certify that I am the person identified above and either a veteran of the US Armed Forces, a current
  US military servicemember, or a spouse. This review is based on my own experience and is my genuine opinion. I have
  not been offered any incentive or payment originating from the organization to write this review. I understand
  that Vet It has a zero-tolerance policy on fake reviews, and would like for my review to be shared through
  this website.
  `
}